var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBillingNew(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 9.99927H2.5C1.1225 9.99927 0 11.1218 0 12.4993V34.9993C0 36.3793 1.1225 37.4993 2.5 37.4993H37.5C38.88 37.4993 40 36.3793 40 34.9993V12.4993C40 11.1218 38.88 9.99927 37.5 9.99927Z",
    fill: "#0099FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 14.9993H0V22.4993H40V14.9993Z",
    fill: "#455A64"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 29.9993H6.25C5.56 29.9993 5 29.4393 5 28.7493C5 28.0593 5.56 27.4993 6.25 27.4993H11.25C11.94 27.4993 12.5 28.0593 12.5 28.7493C12.5 29.4393 11.94 29.9993 11.25 29.9993Z",
    fill: "#FAFAFA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40 22.3643V12.4993C40 11.1218 38.88 9.99927 37.5 9.99927H17.5V12.4993C17.5 20.3293 20.48 25.0968 28.14 29.5068C28.705 29.8293 29.35 29.9993 30 29.9993C30.65 29.9993 31.295 29.8293 31.8675 29.5018C35.6575 27.3243 38.2975 25.0518 40 22.3643Z",
    fill: "#FAFAFA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2425 6.35198L30.4925 2.60198C30.175 2.46698 29.8225 2.46698 29.505 2.60198L20.755 6.35198C20.2975 6.54698 20 6.99948 20 7.49948V12.4995C20 19.377 22.5425 23.397 29.3775 27.3345C29.57 27.4445 29.785 27.4995 30 27.4995C30.215 27.4995 30.43 27.4445 30.6225 27.3345C37.4575 23.407 40 19.387 40 12.4995V7.49948C40 6.99948 39.7025 6.54698 39.2425 6.35198Z",
    fill: "#29CC6A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.75 18.7494C28.7325 18.7494 28.7125 18.7494 28.6975 18.7494C28.3 18.7319 27.9325 18.5269 27.71 18.1944L25.21 14.4444C24.8275 13.8694 24.9825 13.0944 25.5575 12.7119C26.1275 12.3319 26.905 12.4819 27.29 13.0594L28.8425 15.3869L32.7725 10.4719C33.205 9.93435 33.9925 9.84935 34.53 10.2769C35.07 10.7094 35.155 11.4944 34.725 12.0344L29.725 18.2844C29.4875 18.5769 29.1275 18.7494 28.75 18.7494Z",
    fill: "#FAFAFA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillingNew);
export default __webpack_public_path__ + "static/media/billingNew.6b3d6d28d7824e7cc6be6a8e19d7d9c6.svg";
export { ForwardRef as ReactComponent };